import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Loja from "../views/Loja.vue";
import Checkout from "../views/Checkout.vue";
import Categorias from "../views/Categorias.vue";
import Carrinho from "../views/Carrinho.vue";
import Login from "../views/Login.vue";
import EsqueceuSenha from "../views/EsqueceuSenha.vue";
import UsuarioCadastrar from "../views/UsuarioCadastrar.vue";
import UsuarioCadastrarSportheca from "../views/UsuarioCadastrarSportheca.vue";
import UsuarioAtualizar from "../views/UsuarioAtualizar.vue";
import AlterarSenha from "../views/AlterarSenha.vue";
import ValidarCodigo from "../views/ValidarCodigo.vue";
import Pedidos from "../views/Pedidos.vue";
import DetalhesPedido from "../views/DetalhesPedidos.vue";
import Assinaturas from "../views/Assinaturas.vue";
import DetalhesAssinatura from "../views/DetalhesAssinaturas.vue";
import PlanoCliente from "../views/PlanoCliente.vue";
import DetalhesPlanoCliente from "../views/DetalhesPlanoCliente.vue";
import Pagina from "../views/Pagina.vue";
import RedirectServicos from "../views/RedirectServicos.vue";
import ServicoAgendamentos from "../views/ServicoAgendamentos.vue";
import AceitePlanoCliente from "../components/planoCliente/AceitePlanoCliente.vue";
import Indicacao from "../views/Indicacao.vue";
import MinhasParcelas from "../components/planoCliente/MinhasParcelas.vue";
import DetalhesParcela from "../components/planoCliente/DetalhesParcela.vue";
import StepPix from "../components/assinaturas/StepPix.vue";
import StepBoleto from "../components/assinaturas/StepBoleto.vue";
import StepPagamento from "../components/assinaturas/StepPagamento.vue";
import StepEndereco from "../components/assinaturas/StepEndereco.vue";
import MinhasRecorrencias from "../components/planoCliente/MinhasRecorrencias.vue";
import GerenciarCartoes from "../components/carteira-digital/cartao/GerenciarCartoes.vue";
import SolicitarCartaoBeneficio from "../components/carteira-digital/cartao/SolicitarCartaoBeneficio.vue";
import CheckoutAssinatura from "../components/assinaturas/CheckoutAssinatura.vue";
import SimuladorStep1 from "../components/assinaturas/SimuladorStep1.vue";
import SimuladorStep2 from "../components/assinaturas/SimuladorStep2.vue";
import SimuladorStep3 from "../components/assinaturas/SimuladorStep3.vue";
import SimuladorStep4 from "../components/assinaturas/SimuladorStep4.vue";
import StepAssociados from "../components/assinaturas/StepAssociados.vue";
import EncerrarConta from "../views/EncerrarConta.vue";
import ClubeDesconto from "../views/ClubeDesconto.vue";
import ClubeDescontoNew from "../views/ClubeDescontoNew.vue";
import DetalhesClubeDesconto from "../views/DetalhesClubeDesconto.vue";
import DetalhesClubeDescontoNew from "../views/DetalhesClubeDescontoNew.vue";
import ClubeDescontoCategoriaNew from "../views/ClubeDescontoCategoriaNew.vue";
import Landing from "../views/Landing.vue";
import AgendarConsulta from "../components/tele-medicina/AgendarConsulta.vue";
import AgendamentoFinalizado from "../components/tele-medicina/AgendamentoFinalizado.vue";
import AgendamentoCancelado from "../components/tele-medicina/AgendamentoCancelado.vue";
import VisualizarAgendamentos from "../components/tele-medicina/VisualizarAgendamentos.vue";
import Agendar from "../components/tele-medicina/Agendar.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: `/`,
    component: Home,
    props: true,
    children: [
      {
        path: ``,
        name: "loja",
        component: Loja,
      },
      {
        path: `/loja`,
        name: "loja",
        component: Loja,
      },
      {
        path: `/planos`,
        name: "loja",
        component: Loja,
      },
      {
        path: `/loja/ifly-sao-paulo`,
        name: "loja",
        component: Loja,
      },
      {
        path: `/loja/ifly-brasilia`,
        name: "loja",
        component: Loja,
      },
      {
        path: `/categorias`,
        name: "categorias",
        component: Categorias,
      },
      {
        path: `/checkout`,
        name: "checkout",
        component: Checkout,
      },
      {
        path: `/carrinho`,
        name: "carrinho",
        component: Carrinho,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/carrinho/:pedidoId`,
        name: "carrinho",
        component: Carrinho,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/login`,
        name: "login",
        component: Login,
      },
      {
        path: `/esqueceu-senha`,
        name: "esqueceuSenha",
        component: EsqueceuSenha,
      },
      {
        path: `/cadastrar`,
        name: "cadastrar",
        component: UsuarioCadastrar,
      },
      {
        path: `/cadastrarSportheca`,
        name: "cadastrarSportheca",
        component: UsuarioCadastrarSportheca,
      },
      {
        path: `/validar-codigo`,
        name: "validarCodigo",
        component: ValidarCodigo,
      },
      {
        path: `/Landing`,
        name: "Landing",
        component: Landing,
      },
      {
        path: `/meu-perfil`,
        name: "usuarioAtualizar",
        component: UsuarioAtualizar,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/alterar-senha`,
        name: "UsuarioAlterarSenha",
        component: AlterarSenha,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/pedidos`,
        name: "pedidos",
        component: Pedidos,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/pedidos/:idPedido`,
        name: "detalhes-pedido",
        component: DetalhesPedido,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/assinaturas`,
        name: "assinaturas",
        component: Assinaturas,
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: `/minhas-parcelas/:recorrenciaId`,
        name: "minhas-parcelas",
        component: MinhasParcelas,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/detalhes-parcela/:recorrenciaId/:pagamentoId`,
        name: "detalhes-parcela",
        component: DetalhesParcela,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/pagamento-pix/:cobrancaPixId`,
        name: "pix",
        component: StepPix,
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: `/minhas-recorrencias`,
        name: "minhas-recorrencias",
        component: MinhasRecorrencias,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/simulador/:idPlano`,
        name: "simulador",
        component: SimuladorStep1,
      },
      {
        path: `/planos/simulador-step-2`,
        name: "simulador-step-2",
        component: SimuladorStep2,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/simulador-step-3`,
        name: "simulador-step-3",
        component: SimuladorStep3,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/simulador-step-4`,
        name: "simulador-step-4",
        component: SimuladorStep4,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/dependentes/:planoId`,
        name: "planos-dependentes",
        component: StepAssociados,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/checkout`,
        name: "checkoutAssinatura",
        component: CheckoutAssinatura,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/checkout/pix/:planoId/:assinaturaId`,
        name: "checkoutAssinaturaPix",
        component: StepPix,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/checkout/Boleto/:planoId/:assinaturaId`,
        name: "checkoutAssinaturaBoleto",
        component: StepBoleto,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/checkout/Boleto/:pedidoId/:boletoId/:tipo`,
        name: "checkoutAssinaturaBoleto",
        component: StepBoleto,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/checkout/endereco/:planoId/:assinaturaId`,
        name: "checkoutAssinaturaEndereco",
        component: StepEndereco,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/checkout/cadastro`,
        name: "checkoutAssinaturaCadastro",
        component: UsuarioAtualizar,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/planos/checkout/cartao-credito/:planoId/:assinaturaId`,
        name: "checkoutAssinaturaCartaoCredito",
        component: StepPagamento,
        meta: {
          requiresAuth: true,
        },
      },

      {
        path: `/assinatura-detalhes/:idAssinatura/:idPlanoAssinatura?/:associados?`,
        name: "detalhes-assinatura",
        component: DetalhesAssinatura,
      },
      {
        path: `/plano-do-cliente/:idAssinatura`,
        name: "plano-cliente",
        component: PlanoCliente,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/plano-do-cliente/:idAssinatura/:idDetalhes`,
        name: "detalhes-plano-cliente",
        component: DetalhesPlanoCliente,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/redirect-servicos/:idServico`,
        name: "redirect-servicos",
        component: RedirectServicos,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/indicacao`,
        name: "minhas-indicacoes",
        component: Indicacao,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/servicos-agendamento`,
        name: "servicos-agendamento",
        component: ServicoAgendamentos,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/aceite-plano-cliente-associacao/:idPlano`,
        name: "aceite-plano-cliente",
        component: AceitePlanoCliente,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/:idPlano`,
        name: "aceite-plano-cliente",
        component: AceitePlanoCliente,
        meta: {
          requiresAuth: false,
        },
      },
      {
        path: `/pagina/:pagina`,
        name: "pagina",
        component: Pagina,
      },
      {
        path: `/carteira-digital/cartao/listar`,
        name: "gerenciar-cartoes",
        component: GerenciarCartoes,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/conta/encerrar-conta`,
        name: "encerrar-conta",
        component: EncerrarConta,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/carteira-digital/cartao/solicitar-cartao-beneficio`,
        name: "solicitar-cartao-beneficio",
        component: SolicitarCartaoBeneficio,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/servico/clube-desconto`,
        name: "ClubeDesconto",
        component: ClubeDesconto,
      },
      {
        path: `/servico/clube-desconto/:idDetalhe`,
        name: "DetalhesClubeDesconto",
        component: DetalhesClubeDesconto,
      },
      {
        path: `/servico/tele-medicina/agendamento`,
        name: "AgendarConsulta",
        component: AgendarConsulta,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/servico/tele-medicina/agendamento-finalizado`,
        name: "AgendamentoFinalizado",
        component: AgendamentoFinalizado,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/servico/tele-medicina/agendamento-cancelado`,
        name: "AgendamentoCancelado",
        component: AgendamentoCancelado,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: `/servico/tele-medicina/agendamentos-cliente`,
        name: "AgendamentosCliente",
        component: VisualizarAgendamentos,
        meta: {
          requiresAuth: true,
        },
      }, 
      {
        path: `/servico/tele-medicina/agendar`,
        name: "Agendar",
        component: Agendar,
        meta: {
          requiresAuth: true,
        },
      }, 
      {
        path: `/:urlSlug/clube-de-descontos`,
        name: "ClubeDescontoNew",
        component: ClubeDescontoNew,
      },
      {
        path: `/:urlSlug/clube-de-descontos/:offerId`,
        name: "DetalhesClubeDescontoNew",
        component: DetalhesClubeDescontoNew,
      },
      {
        path: `/:urlSlug/clube-de-descontos/categoria/:categoryId`,
        name: "ClubeDescontoCategoriaNew",
        component: ClubeDescontoCategoriaNew,
      },
      {
        path: "*",
        redirect: "",
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (to.query.accessToken) {
      next();
      return;
    }
    if (sessionStorage.getItem("token") == null) {
      next({
        path: `/login/`,
        query: { nextUrl: to.fullPath },
      });
    } else {
      next();
      return;
    }
  } else {
    next();
  }
});

export default router;
